import styled from '@emotion/styled';

export const EmailContainer = styled.div`
  background: ${({ $isMyMessage, theme }) =>
    $isMyMessage ? theme?.colors?.light || '#f8f9fa' : theme?.colors?.white || '#FFFFFF'};
  border: 1px solid ${({ theme }) => theme?.colors?.borderColor || '#D4D8DD'};
  border-radius: 8px;
  padding: 16px;
  margin: 8px 0;
  max-width: 100%;
  font-family: ${({ theme }) => theme?.fonts?.main || '"Nunito", sans-serif'};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const EmailSubject = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme?.colors?.primaryText || '#212529'};
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme?.colors?.borderColor || '#D4D8DD'};
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
`;

export const EmailHeader = styled.div`
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme?.colors?.borderColor || '#D4D8DD'};
`;

export const EmailHeaderRow = styled.div`
  display: flex;
  margin-bottom: 6px;
  font-size: 14px;
  align-items: flex-start;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const EmailHeaderLabel = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme?.colors?.secondaryText || '#6C757D'};
  min-width: 80px;
  flex-shrink: 0;
`;

export const EmailHeaderValue = styled.span`
  color: ${({ theme }) => theme?.colors?.text || '#333'};
  word-wrap: break-word;
  word-break: break-word;
  flex: 1;
`;

export const EmailBody = styled.div`
  margin-bottom: 0;
`;

export const EmailBodyText = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme?.colors?.text || '#333'};
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-word;
  font-family: ${({ theme }) => theme?.fonts?.main || '"Nunito", sans-serif'};
`;

export const EmailBodyLink = styled.a`
  color: ${({ theme }) => theme?.colors?.secondary || '#2D6CDF'};
  text-decoration: underline;
  cursor: pointer;
  word-break: break-all;

  &:hover {
    color: ${({ theme }) => theme?.colors?.primary || '#1D3557'};
  }

  &:visited {
    color: ${({ theme }) => theme?.colors?.primary || '#1D3557'};
  }
`;

export const AttachmentsSection = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme?.colors?.borderColor || '#D4D8DD'};
`;

export const AttachmentItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  margin-top: 8px;
  background: ${({ theme }) => theme?.colors?.white || '#FFFFFF'};
  border: 1px solid ${({ theme }) => theme?.colors?.borderColor || '#D4D8DD'};
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme?.colors?.hoverHighlight || '#f0f7ff'};
    border-color: ${({ theme }) => theme?.colors?.secondary || '#2D6CDF'};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &:first-of-type {
    margin-top: 12px;
  }
`;

export const AttachmentPreview = styled.div`
  width: 56px;
  height: 56px;
  min-width: 56px;
  margin-right: 16px;
  border-radius: 12px;
  background: ${({ theme }) => theme?.colors?.background || '#e8e8e8'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #6b6b6b;
`;

export const AttachmentIconSvg = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
    fill: #6b6b6b;
  }
`;

export const AttachmentInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 4px;
`;

export const AttachmentName = styled.a`
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.text || '#1a1a1a'};
  text-decoration: none;
  cursor: pointer;
  word-wrap: break-word;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  margin-bottom: 4px;
  line-height: 1.4;

  &:hover {
    color: ${({ theme }) => theme?.colors?.secondary || '#2D6CDF'};
    text-decoration: underline;
  }
`;

export const AttachmentSize = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme?.colors?.secondaryText || '#888'};
  font-weight: 400;
`;
